import { Identifiable, Project } from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { reduceProject } from "../../common/project";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  projects: [],
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(state: State, projects: Identifiable<Project>[]): State {
  return { ...state, request: setRequestStateToSuccess(), projects };
}

function handleFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

function propagateEvent(state = initialState, event: Event): State {
  return {
    ...state,
    projects: state.projects.map((project) => reduceProject(project, event)),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveProjectHistoryRequested]: handleRequest,
      [events.retrieveProjectHistorySucceeded]: handleSuccess,
      [events.retrieveProjectHistoryFailed]: handleFailure,
    },
    propagateEvent,
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
